// AdminSkeletons.tsx

import React from "react";

export const AppAdminMenuButtonCardSkeleton = () => {
  return (
    <div className="gx-app-admin-menu-box skeleton">
      <div className="gx-app-admin-menu-label-avatar">
        <div className="gx-a-skeleton-icon" />
        <p className="gx-a-skeleton-text" />
      </div>
      <div className="gx-a-skeleton-arrow" />
    </div>
  );
};

export const AccountCardSkeleton = () => {
  return (
    <div className="gx-accountaccess-card-menu gx-a-skeleton">
      <div className="gx-app-admin-menu-label-avatar">
        <div className="gx-a-account-skeleton-icon" />
        <div className="gx-a-nn-wrapper">
          <p className="gx-a-skeleton-text-l" />
          <p className="gx-a-skeleton-text" />
        </div>
      </div>
    </div>
  );
};

export const AdminProductCardSkeleton = () => {
  return (
    <div className="gx-transaction-card-menu gx-a-skeleton">
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center">
          <p className="gx-a-skeleton-text" />
        </div>
        <div className="gx-a-skeleton-arrow" />
      </div>
    </div>
  );
};


export const UserListSkeleton = ({ count }: { count: number }) => {
  // Generate a stable array of IDs for keys
  const skeletonIds = React.useMemo(
    () => Array.from({ length: count }, () => crypto.randomUUID()),
    [count]
  );

  return (
    <div className="gx-user-list-box gx-scroll-section">
      {skeletonIds.map((id) => (
        <div className="px-3 gx-uar-card" key={id}>
          <div className="flex flex-col w-full my-3 gap-y-3">
            <div className="flex items-center justify-between gap-x-2">
              {/* Avatar */}
              <div className="gx-skeleton gx-skeleton-circle gx-skeleton-dark w-[38px] h-[38px]"></div>

              <div className="flex items-center justify-between basis-full">
                <div>
                  <div className="gx-skeleton gx-skeleton-light h-[14px] w-[120px] mb-2"></div>
                  <div className="gx-skeleton gx-skeleton-light h-[10px] w-[160px]"></div>
                </div>

                <div className="flex justify-between items-center gap-2">
                  <div className="gx-skeleton gx-skeleton-dark h-[16px] w-[60px]"></div>
                  <div className="gx-skeleton gx-skeleton-circle gx-skeleton-dark h-[8px] w-[8px]"></div>
                </div>
              </div>
            </div>

            <div className="flex flex-col gap-y-[0.6rem]">
              <div className="flex justify-between">
                <div className="gx-skeleton gx-skeleton-light h-[12px] w-[100px]"></div>
                <div className="gx-skeleton gx-skeleton-dark h-[12px] w-[80px]"></div>
              </div>

              <div className="flex justify-between">
                <div className="gx-skeleton gx-skeleton-light h-[12px] w-[120px]"></div>
                <div className="gx-skeleton gx-skeleton-dark h-[12px] w-[100px]"></div>
              </div>

              <div className="flex justify-between">
                <div className="gx-skeleton gx-skeleton-light h-[12px] w-[80px]"></div>
                <div className="gx-skeleton gx-skeleton-dark h-[12px] w-[120px]"></div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

// Mirrors the layout of a real ".gx-auth-group-item" row (code + name on the
// left, edit/delete icon actions on the right) so it doesn't cause layout
// shift when the real data swaps in.
export const AuthGroupItemSkeleton = ({ count = 4 }: { count?: number }) => {
  const skeletonIds = React.useMemo(
    () => Array.from({ length: count }, () => crypto.randomUUID()),
    [count]
  );

  return (
    <>
      {skeletonIds.map((id) => (
        <div className="gx-auth-group-item border-gray-200!" key={id}>
          <div className="gx-auth-group-info">
            <div className="gx-skeleton gx-skeleton-dark h-[10px] w-[36px] mb-2"></div>
            <div className="gx-skeleton gx-skeleton-light h-[14px] w-[130px]"></div>
          </div>
          <div className="gx-auth-group-item-actions flex items-center gap-2">
            <div className="gx-skeleton gx-skeleton-circle gx-skeleton-dark w-[20px] h-[20px]"></div>
            <div className="gx-skeleton gx-skeleton-circle gx-skeleton-dark w-[20px] h-[20px]"></div>
          </div>
        </div>
      ))}
    </>
  );
};
